require('./externalTransferFundStep3New.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
// @ commons
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { AmountInput } = require('commonsComponents/amountInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ helpers
const { getCurrencySymbol } = require('utilities/currencyHelper');

// @ constants
const {
    BROKER_TRANSFER_EXTERNAL_FUND_TOTAL,
    BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL,
    BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_AMOUNT,
    BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_PARTICIPATION,
    BROKER_FUNDS_PARTICIPATIONS_DECIMALS,
    BROKER_FUNDS_PARTIAL_AMOUNT_DECIMALS,
    BROKER_FUNDS_EXTERNAL_TRANSFER_PARTICIPATIONS_INTEGER_LENGTH,
    BROKER_FUNDS_EXTERNAL_TRANSFER_PARTICIPATIONS_MINIMUM_VALUE,
    BROKER_FUNDS_EXTERNAL_TRANSFER_PARTICIPATIONS_MAXIMUM_VALUE,
} = require('constants/index');

class ExternalTransferFundStep3New extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };
        this.onAmountChange = this.onAmountChange.bind(this);
    }

    componentDidMount() {
        this.props.resetAmountDirty();
    }

    onAmountChange(amount) {
        this.props.setAmount(amount);
    }


    buildInput() {
        const { immExternalTransferFund, setSubtype } = this.props;
        if (immExternalTransferFund.getIn(['steps', 2, 'type']) === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL) {
            const subType = immExternalTransferFund.getIn(['steps', 2, 'subType']);
            const amount = immExternalTransferFund.getIn(['steps', 2, 'amount']);
            const amountCurrency = getCurrencySymbol({
                currency: immExternalTransferFund.getIn(['originFund', 'currency']),
                value: immExternalTransferFund.getIn(['steps', 2, 'amount'])
            });

            const amountDirty = immExternalTransferFund.getIn(['steps', 2, 'amountDirty']);
            const errorMessage = subType === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_AMOUNT ?
                formatText('brokerExternalTransferFundStep3-errorInputAmountMessage') :
                formatText('brokerExternalTransferFundStep3-errorInputParticipationMessage');
            const radioButtonPartial = (
                <RadioButtonGroup
                    name="partialSubtype"
                    idPrefix="subTyeRadioButtonGroup"
                    className="external-transfer-fund-step3__radio-button-group"
                    selectedValue={subType}
                    onChange={setSubtype}
                >
                    <RadioButton
                        value={BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_AMOUNT}
                        label={formatText('brokerExternalTransferFundStep3-InputAmountLabel')}
                        className="external-transfer-fund-step3__radio-button-partial"
                    />
                    <RadioButton
                        value={BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_PARTICIPATION}
                        label={formatText('brokerExternalTransferFundStep3-InputParticipationLabel')}
                        className="external-transfer-fund-step3__radio-button-partial"
                    />
                </RadioButtonGroup>
            );
            return (
                <React.Fragment>
                    {radioButtonPartial}
                    <div className="external-transfer-fund-step3__input-container">
                        <AmountInput
                            amount={amount}
                            min={BROKER_FUNDS_EXTERNAL_TRANSFER_PARTICIPATIONS_MINIMUM_VALUE}
                            max={BROKER_FUNDS_EXTERNAL_TRANSFER_PARTICIPATIONS_MAXIMUM_VALUE}
                            callback={this.onAmountChange}
                            error={amountDirty}
                            errorMsg={errorMessage}
                            maxFractionLength={
                                immExternalTransferFund.getIn(['steps', 2, 'subType']) === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_AMOUNT
                                ? BROKER_FUNDS_PARTIAL_AMOUNT_DECIMALS
                                : BROKER_FUNDS_PARTICIPATIONS_DECIMALS
                            }
                            maxIntegerLength={BROKER_FUNDS_EXTERNAL_TRANSFER_PARTICIPATIONS_INTEGER_LENGTH}
                            maxBackEndFractionLength={
                                immExternalTransferFund.getIn(['steps', 2, 'subType']) === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_AMOUNT
                                ? BROKER_FUNDS_PARTIAL_AMOUNT_DECIMALS
                                : BROKER_FUNDS_PARTICIPATIONS_DECIMALS
                            }
                            keepZeroAndEmpty={true}
                            language={getLanguage()}
                            inlineUnit={
                                immExternalTransferFund.getIn(['steps', 2, 'subType']) === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_AMOUNT
                                ? amountCurrency
                                : null
                            }
                    />
                    </div>
                </React.Fragment>
            );
        }
    }


    buildRadioButtons() {
        const { immExternalTransferFund, setType } = this.props;
        const type = immExternalTransferFund.getIn(['steps', 2, 'type']);

        return (
            <RadioButtonGroup
                name="motive"
                idPrefix="cancelChequebookMotiveRadio"
                className="external-transfer-fund-step3__radio-button-group"
                selectedValue={type}
                onChange={setType}
            >
                <RadioButton
                    value={BROKER_TRANSFER_EXTERNAL_FUND_TOTAL}
                    label={formatText('brokerExternalTransferFundStep3-total')}
                />
                <RadioButton
                    value={BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL}
                    label={formatText('brokerExternalTransferFundStep3-partial')}
                />
            </RadioButtonGroup>
        );
    }

    render() {
        const radioButtonsContainer = this.buildRadioButtons();
        const inputContainer = this.buildInput();
        const typeOfTransferOptions = (
            <React.Fragment>
                <FormattedText
                    value="brokerExternalTransferFundStep3-subtitle2"
                    className="external-transfer-fund-step3__subtitle2"
            />
                <div className="external-transfer-fund-step3__tooltip">
                    <OKTooltip
                        content="brokerExternalTransferFundStep3-tooltip"
                        offset={[0,-15]}
                />
                </div>
                <FormattedText
                    value="brokerExternalTransferFundStep3-type"
                    className="external-transfer-fund-step3__type"
            />
                {radioButtonsContainer}
                {inputContainer}
            </React.Fragment>
        );

        return (
            <div className="external-transfer-fund-step3">
                {typeOfTransferOptions}
            </div>
        );
    }
}

ExternalTransferFundStep3New.propTypes = {
    immExternalTransferFund: PropTypes.object.isRequired,
    resetAmountDirty: PropTypes.func.isRequired,
    setType: PropTypes.func.isRequired,
    setSubtype: PropTypes.func.isRequired,
    setAmount: PropTypes.func.isRequired,
};

module.exports = ExternalTransferFundStep3New;
